import React from 'react';

import { useSelector } from 'react-redux';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import "react-datepicker/dist/react-datepicker.css";

import Input from '../UI/Input';

import classes from './BoardMember.module.css';

const CommitteeForm = ({committee, edit, onSubmit, onCancel, onDelete}) => {
  const auth = useSelector(state => state.auth);
  
  const schema = Yup.object({
    name: Yup.string()
      .min(3, 'Committee name too short')
      .max(128, "Invalid committee name"),
    description: Yup.string()
      .required()
  });

  const formik = useFormik({
    initialValues: {
      id: committee.id,
      name: committee.name,
      description: committee.description,
      chair_id: committee.chair_id,
      members: committee.members,
      is_board: committee.is_board
    },
    validateOnChange: true,
    validationSchema: schema,
    onSubmit: (values) => {
      console.log(`CommitteeForm: onSubmit: formikErrors: ${formik.errors}`, values)
      onSubmit({...values})
    }
  })

  /**
   * 
   * @returns Build a list of CommitteeMembers for choosing a chair
   */
  const renderMemberList = () => {
    const members = committee.members.map((cm) => {
      return <option key={`${cm.id}-${cm.name}`} value={cm.id}>{cm.name}</option>
    })
    return members;
  }

  const handleChairChange = (event) => {
    formik.setFieldValue('chair_id', event.target.value)
  }

  const renderCommitteeMembers = () => {
    if (edit && committee.members.length > 0) {
      return (
        <InputGroup>
          <InputGroup.Prepend>
            <InputGroup.Text id="chair_id">Chair</InputGroup.Text>
          </InputGroup.Prepend>
          <Form.Control
            id="chair_id" name="chair_id"
            as="select" 
            value={formik.values.chair_id}
            onChange={handleChairChange}
            isInvalid={formik.errors.role_type}
          >
            <option value="0">[Select]</option>
            {renderMemberList()}
          </Form.Control>
        </InputGroup>
      )
    }
    return null;
  }

  const renderDeleteButton = () => {
    if (edit) {
      return (
        <Button style={{marginLeft: '40px'}} type="button" onClick={() => onDelete()}>
          <FontAwesomeIcon
            icon={faTrash}
            size="1x"
            className={[classes.Icon, classes.DeleteButton].join(' ')}
          />
          Delete
        </Button>
      )
    }
    return null;
  }

  const renderTitle = () => {
    let titleText = "Add Committee";
    if (edit) {
      titleText = `Editing ${committee.name}'s Info`;
    }
    return <h5 style={{textAlign: 'center'}}>{titleText}</h5>
  }

  return (
    <div>
      <Row>
        <Col sm={3}></Col>
        <Col sm={6}>
          <h5 style={{color: 'red', textAlign: 'center'}}>{auth.error}</h5>
          {renderTitle()}
          <Form
            onSubmit={formik.handleSubmit}
            className={classes.Form}
            autoComplete='off'
          >
            <InputGroup className={classes.InputGroup}>
              <Input
                id='name'
                name='name'
                label='Committee Name'
                placeholder="Specify the name of the committe"
                value={formik.values.name}
                changed={formik.handleChange}
                blur={formik.handleBlur}
                errors={formik.errors.name}
                touched={formik.touched.name}
              />
            </InputGroup>
            <InputGroup className={classes.InputGroup}>
              <Input
                id='description'
                name='description'
                label='Committee Description'
                placeholder="Add a description of the committe"
                value={formik.values.description}
                changed={formik.handleChange}
                blur={formik.handleBlur}
                errors={formik.errors.description}
                touched={formik.touched.description}
              />
            </InputGroup>

            {renderCommitteeMembers()}
            <input type="hidden" name="is_board" value={formik.values.is_board} />
            <InputGroup>
              <InputGroup.Prepend className={classes.InputGroup} />
              <InputGroup.Append>
                <Button type="submit" >{(edit ? "Update Committee" : "Create Committee")}</Button>
                  &nbsp;&nbsp;&nbsp;
                <Button type="cancel" onClick={onCancel} >Cancel</Button>
                {renderDeleteButton()}
              </InputGroup.Append>              
            </InputGroup>
          </Form>
        </Col>
        <Col sm={3}></Col>
      </Row>
    </div>
  );
}

export default CommitteeForm;